import React,{useState,useEffect} from 'react'
import { StateUseContext } from '../../context/UserDetailContext';
import { upadateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';

const FamilyInfo = ({nexTabChange}) => {
    const {userDetail,setUserDetail} = StateUseContext() 

    const [fatherName,setFatherName] = useState({value:'',error:''});
    const [motherName,setMotherName] = useState({value:'',error:''});
    const [fatherEmailAddress,setFatherEmailAddress] = useState({value:'',error:''});
    const [motherEmailAddress,setMotherEmailAddress] = useState({value:'',error:''});
    const [fatherMobileNumber,setFatherMobileNumber] = useState({value:'',error:''});
    const [motherMobileNumber,setMotherMobileNumber] = useState({value:'',error:''});
    const [whatsappNumber,setWhatsappNumber] = useState({value:'',error:''});
    const [motherProfession,setMotherProfession] = useState({value:'',error:''});
    const [motherDesignation,setMotherDesignation] = useState({value:'',error:''});
    const [fatherProfession,setFatherProfession] = useState({value:'',error:''});
    const [fatherDesignation,setFatherDesignation] = useState({value:'',error:''});
    const [motherOrganization,setMotherOrganization] = useState({value:'',error:''});
    const [fatherOrganization,setFatherOrganization] = useState({value:'',error:''});

    const [loading,setLoading] = useState(false);

    const {father_name,mother_name,parent_email,mother_email,
        parent_mobile,mother_mobile,whatsapp_number,mother_profession,mother_designation,mother_company_name,
        parent_profession,parent_designation,parent_company_name} = userDetail !==undefined && userDetail

    useEffect(() => {
        if(userDetail !==undefined){
            setFatherName({...fatherName,value:father_name || ''})
            setMotherName({...motherName,value:mother_name || ''})
            setFatherEmailAddress({...fatherEmailAddress,value:parent_email || ''})
            setMotherEmailAddress({...motherEmailAddress,value:mother_email || ''})
            setFatherMobileNumber({...fatherMobileNumber,value:parent_mobile || ''})
            setMotherMobileNumber({...motherMobileNumber,value:mother_mobile || ''})
            setWhatsappNumber({...whatsappNumber,value:whatsapp_number || ''})
            setMotherProfession({...motherProfession,value:mother_profession || ''})
            setMotherDesignation({...motherDesignation,value:mother_designation || ''})
            setFatherProfession({...fatherProfession,value:parent_profession || ''})
            setFatherDesignation({...fatherDesignation,value:parent_designation || ''})
            setMotherOrganization({...motherOrganization,value:mother_company_name || ''})
            setFatherOrganization({...fatherOrganization,value:parent_company_name || ''})
        }
    },[])

    const validation = () => {
        let formIsValid = true

        if(!fatherName.value){
            formIsValid = false
            let msg = 'Enter father name'
            setFatherName({...fatherName,error:msg});
        }

        if(!motherName.value){
            formIsValid = false
            let msg = 'Enter mother name'
            setMotherName({...motherName,error:msg});
        }
        if(!fatherEmailAddress.value){
            formIsValid = false
            let msg = 'Enter father email address'
            setFatherEmailAddress({...fatherEmailAddress,error:msg});
        }
        if(!motherEmailAddress.value){
            formIsValid = false
            let msg = 'Enter mother email address'
            setMotherEmailAddress({...motherEmailAddress,error:msg});
        }
        if(!fatherMobileNumber.value){
            formIsValid = false
            let msg = 'Enter father mobile number'
            setFatherMobileNumber({...fatherMobileNumber,error:msg});
        }
        if(!motherMobileNumber.value){
            formIsValid = false
            let msg = 'Enter mother mobile number'
            setMotherMobileNumber({...motherMobileNumber,error:msg});
        }
        if(!whatsappNumber.value){
            formIsValid = false
            let msg = 'Enter whatsapp number'
            setWhatsappNumber({...whatsappNumber,error:msg});
        }
        if(!fatherProfession.value){
            formIsValid = false
            let msg = 'Enter father profession'
            setFatherProfession({...fatherProfession,error:msg});
        }
        if(!motherProfession.value){
            formIsValid = false
            let msg = 'Enter mother profession'
            setMotherProfession({...motherProfession,error:msg});
        }
        if(!motherDesignation.value){
            formIsValid = false
            let msg = 'Enter mother designation'
            setMotherDesignation({...motherProfession,error:msg});
        }
        if(!fatherDesignation.value){
            formIsValid = false
            let msg = 'Enter father designation'
            setFatherDesignation({...fatherDesignation,error:msg});
        }
        if(!motherOrganization.value){
            formIsValid = false
            let msg = 'Enter mother organization name'
            setMotherOrganization({...motherOrganization,error:msg});
        }
        if(!fatherOrganization.value){
            formIsValid = false
            let msg = 'Enter father organization name'
            setFatherOrganization({...fatherOrganization,error:msg});
        }

        if(formIsValid){
            setFatherName({...fatherName,error:''})
            setMotherName({...motherName,error:''})
            setFatherEmailAddress({...fatherEmailAddress,error:''});
            setMotherEmailAddress({...motherEmailAddress,error:''});
            setFatherMobileNumber({...fatherMobileNumber,error:''});
            setMotherMobileNumber({...motherMobileNumber,error:''});
            setWhatsappNumber({...whatsappNumber,error:''});
            setFatherProfession({...fatherProfession,error:''});
            setMotherProfession({...motherProfession,error:''});
            setMotherDesignation({...motherProfession,error:''});
            setFatherDesignation({...fatherDesignation,error:''});
            setMotherOrganization({...motherOrganization,error:''});
            setFatherOrganization({...fatherOrganization,error:''});
        }
        
        return formIsValid;
    }

    const submitFormHandler = async(e) => {
        e.preventDefault();
        if(validation()){
            setLoading(true)

            const data = {
                id:userDetail?.id,
                father_name:fatherName.value,
                mother_name:motherName.value,
                parent_email:fatherEmailAddress.value,
                mother_email:motherEmailAddress.value,
                parent_mobile:fatherMobileNumber.value,
                mother_mobile:motherMobileNumber.value,
                whatsapp_number:whatsappNumber.value,
                mother_profession:motherProfession.value,
                mother_designation:motherDesignation.value,
                mother_company_name:motherOrganization.value,
                parent_profession:fatherProfession.value,
                parent_designation:fatherDesignation.value,
                parent_company_name:fatherOrganization.value
            }
            try {
                await upadateProfileDetail(data).then((res) => {
                    if(res.status){
                        setLoading(false);
                        setUserDetail({...userDetail,...res?.data})
                        swal(res?.message,'','success').then(() => {
                            nexTabChange()
                        })
                    }
                    else{
                        setLoading(false);
                        swal(res?.message,'','error')
                    }
                })
            } catch (error) {
                console.log('update profile..',error)
            }
        }
              
    }

  return (
        <form onSubmit={submitFormHandler} className="row mt-3 gx-lg-5">
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Father's Name<span>*</span></label>
                    <input type="text" value={fatherName.value} 
                   
                    onChange={e => {
                        let value = e.target.value
                        value = value.replace(/[^A-Za-z- ]/ig, '') 
                        setFatherName({...fatherName,value:value,error:''})
                        }
                    } 
                    className="form-control"  placeholder="Father's Name"/>
                    {fatherName.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherName.error}</small>}

                </div>
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Mother's Name<span>*</span></label>
                    <input type="text" value={motherName.value} 
                    onChange={e => {
                        let value = e.target.value
                        value = value.replace(/[^A-Za-z- ]/ig, '') 
                        setMotherName({...motherName,value:value,error:''})
                        }
                    }  
                    
                    className="form-control"  placeholder="Mother's Name"/>
                    {motherName.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherName.error}</small>}

                </div>
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Father's Email Address<span>*</span></label>
                    <input type="email" value={fatherEmailAddress.value} onChange={e => setFatherEmailAddress({...fatherEmailAddress,value:e.target.value,error:''})} className="form-control"  placeholder="example@gmail.com"/>
                    {fatherEmailAddress.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherEmailAddress.error}</small>}

                </div>
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Mother's Email Address<span>*</span></label>
                    <input type="email" value={motherEmailAddress.value} onChange={e => setMotherEmailAddress({...motherEmailAddress,value:e.target.value,error:''})} className="form-control"  placeholder="example@gmail.com"/>
                    {motherEmailAddress.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherEmailAddress.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Father's Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        {/* <div className="col-2">
                            <select className="form-control">
                                <option value="">Code</option>
                                <option value="1">+91</option>
                            </select>
                        </div> */}
                        <div className="col-12">
                            <input type="text" value={fatherMobileNumber.value}  
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/\D/g, '')   
                                setFatherMobileNumber({...fatherMobileNumber,value:value,error:''})
                            }}
                            className="form-control" placeholder="Enter mobile number"/>
                        
                        </div>
                    </div>
                    {fatherMobileNumber.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherMobileNumber.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Mother's Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        {/* <div className="col-2">
                            <select className="form-control">
                                <option value="">Code</option>
                                <option value="1">+91</option>
                            </select>
                        </div> */}
                        <div className="col-12">
                            <input type="text" value={motherMobileNumber.value} 
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/\D/g, '')   
                                setMotherMobileNumber({...motherMobileNumber,value:value,error:''})
                            }} 
                            className="form-control" placeholder="Enter mobile number"/>
                        </div>
                    </div>
                    {motherMobileNumber.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherMobileNumber.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">WhatsApp Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        {/* <div className="col-2">
                            <select className="form-control">
                                <option value="">Code</option>
                                <option value="1">+91</option>
                            </select>
                        </div> */}
                        <div className="col-12">
                            <input type="text" value={whatsappNumber.value} 
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/\D/g, '')   
                                setWhatsappNumber({...whatsappNumber,value:value,error:''})
                            }} 
                            className="form-control" placeholder="Enter whatsapp number"/>
                        </div>
                    </div>
                    {whatsappNumber.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{whatsappNumber.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <div className="row gx-3">
                        <div className="col-lg-6">
                            <label className="form-label">Mother's Profession<span>*</span></label>
                            <input type="text" value={motherProfession.value} onChange={e => setMotherProfession({...motherProfession,value:e.target.value,error:''})} placeholder="Enter Mother's Profession"  className="form-control" />
                            {motherProfession.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherProfession.error}</small>}

                        </div>

                        <div className="col-lg-6 mt-2 mt-lg-0">
                            <label className="form-label">Mother's Designation<span>*</span></label>
                            <input type="text" value={motherDesignation.value} onChange={e => setMotherDesignation({...motherDesignation,value:e.target.value,error:''})} placeholder="Enter Mother's Designation"  className="form-control" />
                            {motherDesignation.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherDesignation.error}</small>}

                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row gx-3">
                        <div className="col-lg-6">
                            <label className="form-label">Father's Profession<span>*</span></label>
                            <input type="text" value={fatherProfession.value} onChange={e => setFatherProfession({...fatherProfession,value:e.target.value,error:''})} placeholder="Enter Father's Profession"  className="form-control" />
                            {fatherProfession.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherProfession.error}</small>}

                        </div>

                        <div className="col-lg-6 mt-2 mt-lg-0">
                            <label className="form-label">Father's Designation<span>*</span></label>
                            <input type="text" value={fatherDesignation.value} onChange={e => setFatherDesignation({...fatherDesignation,value:e.target.value,error:''})} placeholder="Enter Father's Designation"  className="form-control" />
                            {fatherDesignation.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherDesignation.error}</small>}

                        </div>
                    </div>
                </div>

            
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Mother's Organization/Company Name<span>*</span></label>
                    <input type="text" value={motherOrganization.value} onChange={e => setMotherOrganization({...motherOrganization,value:e.target.value,error:''})} className="form-control" placeholder="Organization/Company Name"/>
                    {motherOrganization.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherOrganization.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <label  className="form-label">Father's Organization/Company Name<span>*</span></label>
                    <input type="text" value={fatherOrganization.value} onChange={e => setFatherOrganization({...fatherOrganization,value:e.target.value,error:''})} className="form-control" placeholder="Organization/Company Name"/>
                    {fatherOrganization.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherOrganization.error}</small>}

                </div>

                <div className="col-md-12 mt-2">
                {loading ? <button className="btn btn-default" disabled type="button">
                    <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                        Updating...</button>:<button type="submit" className="btn btn-default">Save & Next</button>}
                {/* <button className="btn btn-default ms-2" onClick={e => nexTabChange()} type="button">Next</button> */}
                </div>


        </form>
  )
}

export default FamilyInfo